import { Input } from 'antd';
import type { DescriptionsColumn } from 'components/enmon/descriptions/Descriptions';
import { ManufacturersSelect } from 'components/form/select/ManufacturersSelect';
import { CommoditiesSelect } from '@/components/form/select/CommoditiesSelect';
import type { MeterModelFormValues } from '../types';

type MeterModelFormKeys = keyof MeterModelFormValues;

export const getModelDescriptionColumns = (): DescriptionsColumn<MeterModelFormValues>[] => [
  {
    name: 'name' satisfies MeterModelFormKeys,
    label: 'Name',
    editable: true,
    required: true,
    formItemProps: { required: true, rules: [{ required: true, message: 'Name is required' }] },
    editContent: <Input placeholder="Name" />,
    render: (module: MeterModelFormValues) => module.name,
  },
  {
    name: 'manufacturerId' satisfies MeterModelFormKeys,
    label: 'Manufacturer',
    editable: true,
    editContent: <ManufacturersSelect />,
    render: (module: MeterModelFormValues) => module.manufacturer?.name,
  },
  {
    name: 'commodity' satisfies MeterModelFormKeys,
    label: 'Commodity',
    editable: true,
    required: true,
    formItemProps: {
      required: true,
      rules: [{ required: true, message: 'Commodity is required' }],
    },
    editContent: <CommoditiesSelect allowClear={false} />,
    render: (module: MeterModelFormValues) => module.commodity,
  },
  {
    name: 'website' satisfies MeterModelFormKeys,
    label: 'Website',
    editable: true,
    editContent: <Input allowClear placeholder="http://www.example.com/..." />,
    render: (module: MeterModelFormValues) => module.website,
  },
  {
    name: 'internal_note' satisfies MeterModelFormKeys,
    label: 'Internal note',
    editable: true,
    editContent: (
      <Input.TextArea
        allowClear
        placeholder="White on the pin to the left and green in the right hole... Note on INT3 and 4 the scheme is reversed..."
        rows={6}
      />
    ),
    render: (module: MeterModelFormValues) => module.internal_note,
  },
];
